module.exports = __webpack_public_path__ + "img/foodpanda.69731a31.jpeg";